import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { GrupoInserirComponent } from './grupo-inserir.component';
import { GrupoInserirRoutingModule } from './grupo-inserir-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessagesModule } from 'primeng/messages';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';


@NgModule({
 
  imports: [
    CommonModule,    
    TableModule,
    HttpClientModule,
    GrupoInserirRoutingModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DividerModule,
    DropdownModule,
    FormsModule,
    InputTextareaModule,
    MessagesModule,
    InputNumberModule,
    DialogModule
  ],
  declarations: [
    GrupoInserirComponent
  ]
})
export class GrupoInserirModule { }
